import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Avatar,
  IconButton,
  Box,
  Button,
  Popover,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  IosShare as IosShareIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import http from "../../utils/http-common";
import {
  setPlanForDelete,
  setPlanForEdit,
  setPlanForShare,
  setPlanForView,
} from "../../Slices/planslice";
import Pagination from "@mui/material/Pagination";
const ShareTable = ({ planData = [] }) => {
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "left",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "18px",
    textAlign: "left",
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedId, setSelectedId] = useState(null);
  const [planDetails, setPlanDetails] = useState([]);
  const [sharedData, setSharedData] = useState([]);
  const handleActionOpen = (event, userId, userDetails) => {
    setSelectedId(userId);
    setPlanDetails(userDetails);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAction = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const fetchSharedData = async () => {
      try {
        const response = await http.get("/master_service/get_plan/acess_api/data");
        if (response.status === 200) {
          setSharedData(response.data);
        }
      } catch (error) {
        console.error("Error fetching shared data", error);
      }
    };
    fetchSharedData();
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "user-options-popover" : undefined;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleEdit = () => {
    dispatch(setPlanForEdit({ id: selectedId, isEdit: true, table: false }));
    navigate("/home/createplan");
    handleCloseAction();
  };
  const handleDelete = () => {
    dispatch(
      setPlanForDelete({
        id: selectedId,
        isDelete: true,
        table: false,
      })
    );
    navigate("/home/createplan");
    handleCloseAction();
  };
  const handleView = () => {
    dispatch(setPlanForView({ id: selectedId, isView: true, table: false }));
    navigate("/home/viewplan");
    handleCloseAction();
  };
  const handleShare = () => {
    dispatch(setPlanForShare({ id: selectedId, isShare: true, table: false }));
    navigate("/home/plan-share-screen");
    handleCloseAction();
  };
  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };
  const SharedWithComponent = ({ sharedWithUsers, plan_id, user_id }) => {
    const maxVisibleUsers = 3;
    const relevantData = (sharedWithUsers || []).filter(
      (plan) => plan.org_user_id === user_id && plan.plan_id === plan_id
    );
    
    return (
      <Box display="flex" alignItems="center">
        {relevantData.slice(0, maxVisibleUsers).map((user, index) => (
          <Avatar
            key={index}
            alt={`Profile of ${user.shared_by_username}`}
            src={user.profile}
            sx={{
              width: 20,
              height: 20,
              marginLeft: index > 0 ? -1 : 0,
              border: "2px solid white",
              zIndex: maxVisibleUsers - index,
            }}
          />
        ))}
{relevantData.length > maxVisibleUsers && (
        <Typography sx={{ marginLeft: 1, fontSize: "14px", fontWeight: 500 }}>
          +{relevantData.length - maxVisibleUsers}
        </Typography>
      )}
      </Box>
    );
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 150 }} aria-label='user table'>
          {/* Table Header */}
          <TableHead sx={{ backgroundColor: "#e0eaff", height: "50px" }}>
            <TableRow>
              <TableCell sx={cellStyle}>Project Name</TableCell>
              <TableCell sx={cellStyle}>Customer Name</TableCell>
              <TableCell sx={cellStyle}>Created By</TableCell>
              <TableCell sx={cellStyle}>Created At</TableCell>
              <TableCell sx={cellStyle}>Shared With</TableCell>

              <TableCell sx={cellStyle}>Actions</TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody sx={{ height: "10px" }}>
            {planData.map((user, index) => (
              <TableRow key={user.id}>
                <TableCell sx={dataStyle}>{user.plan_name}</TableCell>
                <TableCell sx={dataStyle}>{user.customer_name}</TableCell>
                <TableCell sx={dataStyle}>{user.created_by}</TableCell>
                <TableCell sx={dataStyle}>
                  {formatDate(user.createdAt)}
                </TableCell>

                <TableCell>
                <SharedWithComponent plan_id = {user.plan_id} user_id = {user.user_id} sharedWithUsers={sharedData} />
                </TableCell>
                <TableCell>
                  <IconButton aria-label='more options'>
                    <MoreVertIcon
                      sx={{ height: "20px", width: "20px" }}
                      onClick={(event) =>
                        handleActionOpen(event, user.id, user)
                      }
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseAction}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <Box sx={{ p: 1, width: "130px" }}>
          <Button
            onClick={handleView}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none", // to keep the text lowercase

              color: "black", // you can adjust color as needed
            }}>
            <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='view-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              View Plan
            </Typography>
          </Button>
          <Button
            onClick={handleEdit}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <EditIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='edit-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Edit Plan
            </Typography>
          </Button>
          <Button
            onClick={handleShare}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <IosShareIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='edit-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
                textAlign: "left",
              }}>
              Share Plan
            </Typography>
          </Button>
          <Button
            onClick={handleDelete}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",

              color: "black",
            }}>
            <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
            <Typography
              id='delete-user'
              variant='body1'
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
              }}>
              Delete Plan
            </Typography>
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default ShareTable;
